import { Headphones } from "lucide-react";

const embedFor = (url) => {
  try {
    const u = new URL(url);
    const host = u.hostname.replace(/^www\./, "");
    if (host.endsWith("soundcloud.com"))
      return { src: `https://w.soundcloud.com/player/?url=${encodeURIComponent(url)}&color=%238b0000&auto_play=false&show_artwork=false&visual=false`, height: 166 };
    if (host === "open.spotify.com" && /^\/(episode|show|track)\//.test(u.pathname))
      return { src: `https://open.spotify.com/embed${u.pathname}`, height: 152 };
    if (/\.(mp3|m4a|aac|ogg|oga|wav|opus)$/i.test(u.pathname)) return { file: true };
  } catch {
    return null;
  }
  return null;
};

export const AudioPlayer = ({ url }) => {
  const embed = embedFor(url);
  return (
    <section className="my-10 border border-[var(--rule)] bg-white p-5" data-testid="article-audio">
      <p className="meta flex items-center gap-2 mb-4 !text-[var(--ink)]"><Headphones size={14} strokeWidth={1.75} /> Listen to this interview</p>
      {embed?.file && <audio controls preload="none" src={url} className="w-full" data-testid="article-audio-player" />}
      {embed?.src && (
        <iframe title="Interview audio" src={embed.src} width="100%" height={embed.height} frameBorder="0" loading="lazy"
          allow="autoplay; clipboard-write; encrypted-media" data-testid="article-audio-embed" />
      )}
      {!embed && (
        <a href={url} target="_blank" rel="noopener noreferrer" className="font-ui text-sm text-[var(--accent)] underline underline-offset-4" data-testid="article-audio-link">
          Open the audio in a new tab
        </a>
      )}
    </section>
  );
};
